import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '@core/componentes/navbar/navbar.component';
import { PROVIDERS_LAYOUT } from '@core/layouts/providers-layout';

@Component({
  selector: 'app-navbar-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent
  ],
  providers: PROVIDERS_LAYOUT,
  templateUrl: './navbar-layout.component.html',
  styleUrls: ['./navbar-layout.component.scss']
})
export class NavBarLayoutComponent {}